import { ChangeDetectionStrategy, Component, Inject, Input, OnInit } from '@angular/core';
import {
  IDataService,
  IReferralPayoutModel,
  IReferralProgramModel,
  IReferralProgramSettings,
} from '../../../../services/data/data-service.interface';
import { getStringValue } from '../../../form-fields/pql-editor/pql-editor.helper';

interface ReferralPayoutsView {
  model: string;
  pql: string;
  modelValue: string;
}

@Component({
  selector: 'gtd-referral-payouts',
  templateUrl: './referral-payouts.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReferralPayoutsComponent implements OnInit {
  @Input() data: IReferralProgramSettings;

  public referralPayoutsView: ReferralPayoutsView[] = [];

  private referralModel: IReferralPayoutModel;

  constructor(@Inject('IDataService') private dataService: IDataService) {}

  public ngOnInit(): void {
    this.referralModel = this.dataService.getData().referral_payout_models;
    this.referralPayoutsView = this.createReferralPayoutsView(this.data.models);
  }

  private createReferralPayoutsView(payouts: IReferralProgramModel[]): ReferralPayoutsView[] {
    return payouts.map((payout) => {
      return {
        model: this.referralModel[payout.referralPayoutModel].name,
        pql: getStringValue(payout.conditions),
        modelValue: payout.payoutModelValue,
      };
    });
  }
}
